import { Box, Checkbox, Flex, Input, Radio, RadioGroup, Stack } from '@chakra-ui/react'

import { FormField } from '../../../../components/FormField'
import { SectionTitle } from '../../../../components/SectionCard'
import { TTransportMode, TTransportRoute } from '../../../../services/Admission/types'
import { IAdmissionStepProps, IRouteForm, TRANSPORT_MODES, TRANSPORT_ROUTES } from '../admissionForm'

/**
 * How many of each mode, outbound and return; "Utiliza integração?" only when mixing modes. In the
 * panel the integration is optional, as the API takes it there (the quantity is checked in both).
 */
export default function TransportStep({
  form,
  update,
  errors,
  isDisabled,
  mode: stepMode = 'form'
}: IAdmissionStepProps) {
  const required = stepMode === 'form'
  const change = (route: TTransportRoute, patch: Partial<IRouteForm>) =>
    update({ transport_routes: { ...form.transport_routes, [route]: { ...form.transport_routes[route], ...patch } } })

  const setMode = (route: TTransportRoute, mode: TTransportMode, quantity: number | null) =>
    change(route, { modes: { ...form.transport_routes[route].modes, [mode]: quantity } })

  return (
    <>
      {TRANSPORT_ROUTES.map(({ value: route, title }, index) => {
        const { modes, integration } = form.transport_routes[route]
        const used = TRANSPORT_MODES.filter(({ value }) => modes[value] !== null).length

        return (
          <Box key={route} mt={index > 0 ? 8 : 0}>
            <SectionTitle>{title}</SectionTitle>
            <FormField error={errors[`transport_routes.${route}`]} htmlFor={`route-${route}`}>
              <Stack id={`route-${route}`} spacing={3}>
                {TRANSPORT_MODES.map(({ value: mode, label }) => {
                  const quantity = modes[mode]

                  return (
                    <Flex
                      key={mode}
                      align={{ base: 'flex-start', sm: 'center' }}
                      gap={4}
                      direction={{ base: 'column', sm: 'row' }}
                    >
                      <Checkbox
                        minW="200px"
                        isChecked={quantity !== null}
                        onChange={(e) => setMode(route, mode, e.target.checked ? 1 : null)}
                        isDisabled={isDisabled}
                      >
                        {label}
                      </Checkbox>
                      {quantity !== null && (
                        <FormField
                          label="Quantidade"
                          error={errors[`transport_routes.${route}.${mode}`]}
                          isRequired
                          display="flex"
                          alignItems="center"
                          gap={2}
                          w="auto"
                        >
                          <Input
                            type="number"
                            min={1}
                            max={10}
                            w="90px"
                            value={quantity || ''}
                            onChange={(e) => setMode(route, mode, e.target.value === '' ? 0 : Number(e.target.value))}
                            isDisabled={isDisabled}
                          />
                        </FormField>
                      )}
                    </Flex>
                  )
                })}
              </Stack>
            </FormField>

            {used > 1 && (
              <FormField
                label="Utiliza integração?"
                error={errors[`transport_routes.${route}.integration`]}
                isRequired={required}
                mt={4}
                htmlFor={`integration-${route}`}
              >
                <RadioGroup
                  id={`integration-${route}`}
                  value={integration}
                  onChange={(value) => change(route, { integration: value as 'yes' | 'no' })}
                  isDisabled={isDisabled}
                >
                  <Stack direction="row" spacing={6}>
                    <Radio value="yes">Sim</Radio>
                    <Radio value="no">Não</Radio>
                  </Stack>
                </RadioGroup>
              </FormField>
            )}
          </Box>
        )
      })}
    </>
  )
}
